import { useMemo, useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { DataSet, DataItemPayload } from 'src/types/global'
import { DatasetEntry } from '@hooks/useCatalog'
import { processSearchResults } from 'src/utils/searchUtils'

interface ResultBoxProps {
  datasets: DatasetEntry[]
  onClose: () => void
  onSelect: (item: DataItemPayload) => void
}

export default function ResultBox({
  datasets,
  onClose,
  onSelect
}: ResultBoxProps) {
  const { myData, catalog } = useMemo(
    () => processSearchResults(datasets),
    [datasets]
  )

  const handleSelectDataSet = useCallback(
    (item: DataSet) => {
      onSelect({
        type: 'dataset',
        source: item.source,
        id: item.id,
        name: item.name
      })
      onClose()
    },
    [onSelect, onClose]
  )

  const hasResults = myData.length > 0 || catalog.length > 0

  if (!hasResults) {
    return (
      <div className="results-box">
        <p className="no-results">
          <FormattedMessage id="search-data.no-results" />
        </p>
      </div>
    )
  }

  return (
    <div className="results-box">
      {myData.length > 0 && (
        <section className="my-data">
          <h2>
            <FormattedMessage id="search-data.my-data.title" />
          </h2>
          <ul>
            {myData.map((item) => (
              <li key={item.id} onClick={() => handleSelectDataSet(item)}>
                <span className="icon icon-table" />
                <span>{item.name}</span>
              </li>
            ))}
          </ul>
        </section>
      )}

      {catalog.length > 0 && (
        <section className="catalog">
          <h2>
            <FormattedMessage id="search-data.catalog.title" />
          </h2>
          <ul>
            {catalog.map((item) => (
              <li key={item.id} onClick={() => handleSelectDataSet(item)}>
                <span className="icon icon-table" />
                <span>{item.name}</span>
              </li>
            ))}
          </ul>
        </section>
      )}
    </div>
  )
}
